import React from 'react'
 
import $ from '../node_modules/jquery/dist/jquery';

 
import { BrowserRouter, Routes, Route ,useParams} from "react-router-dom";
import './Parviz';

import { ForgetPassword, UserMgt, RegFTTH, AddUser, AddGame, GameMgt, UpdateUser, RoleMgt, ChangePassForMySelf, AddRole, Role_SetPermissions, Role_SetUser, UploadProfile, LoginPage, AdminPanel, UploadImageObj, SmsReport, AddRequest, Requests, RequestShow, ContactMgt, AddContact, SendGroupMgt, Set_Contact, TemplateMgt, AddTemplate, SetUserPanel, MessageQuene, AddMessage, AddMessageBatch, MessageSerach, Inbox, Status, UnitMgt, CityMgt, HouseMgt, AddHouse, HousePartMgt, AccountMgt, GameSelector, AccSelector, SetZ, QuickUserCreate, AccUsageTrnReport, PlanMgt, AddPlan, NewGame, ReturnGame, PriceMgt, Regit, RegMgt, GameDetailMgt, AddGameDetail, CategoryMgt, PostMgt, AddPost, AboutGame, ShowPost, GamesList, PriceGameMgt, HomePage, UsageAccMgt, FixedPageConfig, OrderItemForGameDevMgt, GiveAccNow, UseBackupCode, SmsPatternConfig, GamingUserMgt, UpdateGamingUser, EditUsageAcc, GameAccListReportMgt, SendSmsDirect, ImportMessageExcel, ReadyTextMgt, ImportXlsToSms, ChangeImageSys, GameAccRevMgtStarter } from './Page'
import { FileMgt } from './FileMgtEntry'
import { ProductServiceApp, SerailSerachForClient, StartPay } from './SubSystem/ProductService/Pages';
import { BackupServiceApp } from './SubSystem/BackupService/pages';
import { ModemInstallAndServiceApp } from './SubSystem/ModemInstallAndService/pages';
import { SimpleAccountingBookApp } from './SubSystem/SimpleAccountingBook/Pages';
import { LetterGenApp } from './SubSystem/LetterGen/pages';
import { AttacherApp } from './SubSystem/Attacher/pages';
import { EPaymentApp } from './SubSystem/EPayment/Page';
import ProductList, { ClientHubApp, RegUser, ShowProduct } from './SubSystem/ClientHub/Pages';
import { FixedMessage } from './Componet';
import { InBoxApp } from './SubSystem/InBox/pages';
import { ContextManagmentApp } from './SubSystem/ContextManagent/pages';
 

export default class App extends React.Component{

  Title="برنامه من";
 constructor (props)
 {
  console.log("Yes!");
   super(props);
   this.myself=this;    
  this.state =
    {count:0}
   ;
   this.Calc=this.Calc.bind(this);
 }
Calc()
{

   
}
 render()
 {
    


     return <BrowserRouter >
         <Routes>
            

             <Route path="/"  >
                 <Route path="Admin/" element={<AdminPanel />}  >
                     <Route path="Games" element={<GameMgt />} />
                     <Route path="GamePrices/:id" element={<PriceGameStarter/>} />
                     
                     <Route path="NewGame" element={<NewGame />} />
                     <Route path="ReturnGame" element={<ReturnGame />} />
                     <Route path="Prices" element={<PriceMgt />} />
                     <Route path="AccTrnReport" element={<AccUsageTrnReport />} />
                     <Route path="Game/Accounts/:id" element={<AccList />} />
                     <Route path="Game/Add" element={<AddGame id="-1" />} />
                     <Route path="Game/Edit/:id" element={<EditGame />} />
                     <Route path="Requests" element={<Requests />} />
                     <Route path="GameList" element={<GameSelector />} />
                     <Route path="GameAccSummeryList" element={<GameAccListReportMgt />} />
                     <Route path="SendSmsDirect" element={<SendSmsDirect />} />
                     <Route path="SendMessageExcel" element={<ImportMessageExcel />} />
                     
                     <Route path="ReadyTextMgt" element={<ReadyTextMgt />} />
                     
                     <Route path="ImportXlsToSms" element={<ImportXlsToSms  />} />

                     <Route path="GameUsageOrder" element={<UsageAccMgt />} />
                     <Route path="GameList/AccMgt/:id" element={<AccSelector />} />
                     <Route path="GameList/AccMgt/:gameId/SendTo/:type/:accId" element={<SetZ />} />
                     <Route path="GameList/AccMgt/:gameId/SendTo/:type/:accId/CreateQuickUser" element={<QuickUserCreate />} />
                     <Route path="SetGameRev/:id" element={<GameAccRevMgtStarter />} />
                     <Route path="FileMgt" element={<FileMgt />} />
                     <Route path="ChangeIcon" element={<ChangeImageSys />} />
                     <Route path="AboutGame/:id" element={<AboutGame />} />
                         <Route path="Plans" element={<PlanMgt />} />
                     <Route path="RegMgt" element={<RegMgt />} />
                     <Route path="Plan/Add" element={<AddPlan id="-1" />} />
                     <Route path="Plan/Edit/:id" element={<EditPlan />} />
                     <Route path="CatMgt" element={<CategoryMgt />} />

                     <Route path="SmsReport" element={<SmsReport />} />

                     <Route path="Roles" element={<RoleMgt />} />
                        <Route path="Users" element={<UserMgt />} />
                    <Route path="User/Add" element={<div><AddUser /> </div>} />
                     <Route path="User/:UserId" element={<EditUser />} />
                     <Route path="ShowPost/:id" element={<ShowPostNoCache />} />
                     <Route path="UseBackup/:id" element={<UseBackupCode />} />

                     <Route path="UserProfile" element={<UploadProfile />} />
                     <Route path="Role/Add" element={<AddRole RoleId='-1' />} />
                     <Route path="Role/:RoleId" element={<EditRole />} />
                     <Route path="UpdateUsageAcc/:id" element={<EditUsageAcc />} />
                     <Route path="Role_SetPermission/:RoleId" element={<SetPermisson />} />
                     <Route path="Role_SetUser/:RoleId" element={<FRole_SetUser />} />
                         
                     <Route path="PassChange" element={<ChangePassForMySelf />} />
                     <Route path="UploadImageObj/:type/:id" element={<ImageUpload />} />
                     <Route path="Index.html" element={<HomePage/>} />
                     <Route path="GameDetails" element={<GameDetailMgt />} />
                     <Route path="GameDetail/Add" element={<AddGameDetail id="-1" />} />
                     <Route path="GameDetail/Edit/:id" element={<EditGameDetail />} />
                     <Route path="FixedPages" element={<FixedPageConfig />} />
                     <Route path="SmsPatternConfig" element={<SmsPatternConfig />} />
                     
                     <Route path="MustGiveAccGame" element={<OrderItemForGameDevMgt />} />
                     <Route path="SendAccToOrderItem/:id" element={<GiveAccNow />} />
                     <Route path="GamingUsers" element={<GamingUserMgt />} />
                     <Route path="GamingUser/:id" element={<EditGamingUser />} />
                    

                     {ProductServiceApp()}
                     {BackupServiceApp()}
                     {ModemInstallAndServiceApp()}
                     {SimpleAccountingBookApp()}
                     {LetterGenApp()}
                     {AttacherApp()}
                     {EPaymentApp()}
                     {ClientHubApp()}
                     {InBoxApp()}
                     {ContextManagmentApp()}
                 </Route>

                  
                 <Route path="ForgetPassword" element={<ForgetPassword />} />
                 <Route path="Reg" element={<Regit />} />
                 <Route path="RegUser" element={<RegUser />} />
                 <Route path="Products" element={<ProductList anymos="yes" />} />
                 <Route path="ShowProduct/:id" element={<ShowProduct anymos="yes" />} />
                 <Route path="RegFTTH" element={<RegFTTH />} />
                 <Route path="dp/:id" element={<StartPay />} />
                 <Route path="Login" element={<LoginPage />} />
                 <Route path="Games" element={<GamesList />} />
                 <Route path="CheckGrantStatus" element={<SerailSerachForClient />} />
                 <Route path="*" element={<Redirert />} />
                   </Route>
             <Route path="*" element={<Redirert />} />
         </Routes>
     </BrowserRouter>;

 }
}

function EditGameDetail() {
    const queryS = useParams();
    return <AddGameDetail id={queryS.id} />
}

function EditGame() {
    const queryS = useParams();
    return <AddGame id={queryS.id} />
}
function EditPost() {
    const queryS = useParams();
    return <AddPost id={queryS.id} />
}
function ShowPostNoCache() {
    const queryS = useParams();
    return <ShowPost id={queryS.id} key={queryS.id} />
}
function AccList() {
    const queryS = useParams();
    return <AccountMgt id={queryS.id} />
}

/* ویرایش */
function EditPlan() {
    const queryS = useParams();
    return <AddPlan id={queryS.id} />
}
function EditHouse() {
    const queryS = useParams();
    return <AddHouse id={queryS.id} />
}
function PriceGameStarter() {
    const queryS = useParams();
    return <PriceGameMgt id={queryS.id} />
}


function ProvideHouse() {
    const queryS = useParams();
    return <HousePartMgt id={queryS.id} />
}
function SetCont() {
    const queryS = useParams();
    return <Set_Contact id={queryS.id}   />
}
function AddMsg() {
    const queryS = useParams();
    return <AddMessage mobile={queryS.mobile} />
}
function EditTemp() {
    const queryS = useParams();
    return <AddTemplate id={queryS.id} />
}



function EditContact() {
    const queryS = useParams();
    return <AddContact id={queryS.id} editMode={true} />
}
function ImageUpload(props) {
    const queryS = useParams();
    return <UploadImageObj id={queryS.id} type={queryS.type} />
}

function ShowReq(props) {
    const queryS = useParams();
    return <RequestShow id={queryS.id}   />
}

function Redirert(props) {
    setTimeout(() => { document.getElementById('yes').click() }, 300);
    return <span>در حال جا به جایی <a id="yes" href={window.location}>---</a></span>
}
 
 
  function FRole_SetUser() {
    const queryS = useParams();
    return <Role_SetUser RoleId={queryS.RoleId} />

}


function SetPermisson() {
    const queryS = useParams();
    return <Role_SetPermissions RoleId={queryS.RoleId} />

}
function EditRole() {
    const queryS = useParams();
    return <AddRole RoleId={queryS.RoleId} />

}


function EditUser() {
    const queryS = useParams();
    return <UpdateUser UserId={queryS.UserId} />
}
function EditGamingUser() {
    const queryS = useParams();
    return <UpdateGamingUser UserId={queryS.UserId} />
}